import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/auth/AuthProvider";
import AuthCallback from "@/auth/AuthCallback";
import ProtectedRoute from "@/auth/ProtectedRoute";
import AdminRoute from "@/auth/AdminRoute";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import AdminLeads from "@/pages/AdminLeads";
import AdminStripe from "@/pages/AdminStripe";
import Pricing from "@/pages/Pricing";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth return synchronously (not in useEffect) to avoid races
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/leads"
        element={
          <AdminRoute>
            <AdminLeads />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/stripe"
        element={
          <AdminRoute>
            <AdminStripe />
          </AdminRoute>
        }
      />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            background: "#0F4C5C",
            color: "#fff",
            border: "1px solid #082933",
            fontFamily: "'IBM Plex Sans', sans-serif",
            fontSize: "0.85rem",
            letterSpacing: "0.02em",
          },
        }}
      />
    </div>
  );
}

export default App;
